import React, { useState, createContext } from 'react';

type LanguageIdContextType = {
    languageId: number;
    setLanguageId: React.Dispatch<React.SetStateAction<number>>;
};

export const LanguageIdContext = createContext<LanguageIdContextType>({
    languageId: 1,
    setLanguageId: () => {},
});
interface LanguageIdProviderProps{
    children: React.ReactNode;
}
// add children type of react children
export const LanguageIdProvider = ({ children }:LanguageIdProviderProps) => {
    const [languageId, setLanguageId] = useState(1);

    return (
        <LanguageIdContext.Provider value={{ languageId: languageId, setLanguageId: setLanguageId }}>
            {children}
        </LanguageIdContext.Provider>
    );
};
// what is the react childern type?
// https://stackoverflow.com/questions/47914536/what-is-the-react-children-type
